import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { useLoading } from '../../contexts/LoadingContext';
import EagleSpinner from './EagleSpinner';

// Sekwencja, nie losowanie — kolejne komunikaty tłumaczą coraz dłuższe czekanie.
// Ostatni zostaje na ekranie: powrót do "pobieramy dane" po kilkunastu sekundach
// wyglądałby, jakby ładowanie zaczęło się od nowa.
const MESSAGES = [
  'pobieramy potrzebne dane',
  'sprawdzamy ważne informacje',
  'wczytujemy konfigurację',
  'daj nam jeszcze chwilkę',
];

// Tekst pojawia się dopiero przy DŁUŻSZYM ładowaniu. Zwykły request idzie w ~200 ms
// i komunikat zdążyłby tylko mrugnąć — sam orzeł wystarczy.
const TEXT_DELAY_MS = 900;
const MESSAGE_INTERVAL = 2200;

const GlobalSpinner = () => {
  const { isLoading } = useLoading();
  const prefersReducedMotion = useReducedMotion();
  // -1 = ładowanie trwa, ale jeszcze bez tekstu
  const [msgIndex, setMsgIndex] = useState(-1);

  useEffect(() => {
    if (!isLoading) {
      setMsgIndex(-1);
      return;
    }
    let interval;
    // Interwał startuje dopiero z pierwszym komunikatem, żeby każdy był na ekranie
    // tyle samo czasu (przy starcie od razu pierwszy zniknąłby po ~1,3 s).
    const firstMessage = setTimeout(() => {
      setMsgIndex(0);
      interval = setInterval(() => {
        setMsgIndex((prev) => Math.min(prev + 1, MESSAGES.length - 1));
      }, MESSAGE_INTERVAL);
    }, TEXT_DELAY_MS);

    return () => {
      clearTimeout(firstMessage);
      clearInterval(interval);
    };
  }, [isLoading]);

  if (!isLoading) {
    return null; // Nie pokazuj nic, jeśli nie ma ładowania
  }

  const fade = prefersReducedMotion
    ? { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } }
    : {
        initial: { opacity: 0, y: 8 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -8 },
      };

  return (
    <div style={{
      position: 'fixed', // Kluczowe: nakładka na całą stronę
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.85)', // Półprzezroczyste tło
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, // Upewnij się, że jest na samej górze
      backdropFilter: 'blur(3px)', // Efekt "szkła" (opcjonalnie)
    }}>
      <EagleSpinner />

      {/* Stała wysokość — orzeł nie może podskakiwać, gdy tekst się pojawia */}
      <div className="h-7 mt-5 flex items-center justify-center px-8">
        <AnimatePresence mode="wait">
          {msgIndex >= 0 && (
            <motion.p
              key={msgIndex}
              {...fade}
              transition={{ duration: 0.25 }}
              className="text-base text-gray-500 text-center leading-snug"
            >
              {MESSAGES[msgIndex]}
            </motion.p>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default GlobalSpinner;
